import React from "react";
import { alert_error, alert_success } from '../../AppContext';
import axios from 'axios';
import { Cookies } from '../../index.js';
import CountryFlagsUI from './country_flags_ui.jsx';
import NavDownUI from './nav_down_ui.jsx';
import { get_latest_version_text } from '../../js/latest_version.js';

const translations = {
    vi: {
        home: "Trang chủ",
        region: 'Khu vực'
    },
    en: {
        home: "Home",
        region: 'Region'
    }
};

export default function HostnameDropdown() {
    const marketCode = String(Cookies.get('national_market') || 'en').toLowerCase();
    const uiText = marketCode === 'vi' ? translations.vi : translations.en;
    const hostname = window.location.hostname;
    const displayHostname = hostname.includes("tecom.pro") ? "hust.media" : hostname;
    const latestVersion = get_latest_version_text(Cookies.get("latest_version"));
    const usePillStyle = latestVersion === "3" || latestVersion === "5";
    const setNationalUriChangeCookie = (uri) => {
        Cookies.set('national_uri_change', uri, {
            path: '/',
            expires: new Date(Date.now() + 10 * 60 * 1000)
        });
    };

    const change_national = async () => {
        const currentUri = `${window.location.pathname}${window.location.search}${window.location.hash}` || '/';
        setNationalUriChangeCookie(currentUri);
        alert_success('Waiting ...');
        Cookies.remove('national_market');

        try {
            const apikey = Cookies.get('apikey');
            if (!apikey) {
                setTimeout(() => { window.location.href = '/reactapp/convert_national_market'; }, 1000);
            } else {
                const url = `https://hust.media/api/profile/national_market.php?apikey=${apikey}&service_national=change&national_market=delete`;
                const resp = await axios.get(url);
                if (resp.data.status == '1') {
                    setTimeout(() => { window.location.href = '/reactapp/convert_national_market'; }, 150);
                } else {
                    resp.data.message && alert_error(resp.data.message);
                }
            }
        } catch (err) {
            alert_error('Error changing national market:', err);
        }
    };

    return (
            <NavDownUI
                displayHostname={displayHostname}
                homeText={uiText.home}
                regionText={uiText.region}
                homeHref="/reactapp/"
                onRegionClick={change_national}
                regionFlag={<CountryFlagsUI marketCode={marketCode} fallbackCode="en" />}
                usePillStyle={usePillStyle}
            />
    );
}
